module.exports = "pegasus/assets/web_template/location.png";